import { Fragment } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";

export function useEquipmentNavigation() {
  const [params, setParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const openedHere = location.state?.equipmentOpened === location.pathname;
  const back = () => {
    const index = window.history.state?.idx;
    const hasPrevious =
      typeof index === "number" ? index > 0 : location.key !== "default";
    if (hasPrevious) navigate(-1);
    else navigate("/oprema", { replace: true });
  };
  const open = (values: Record<string, string | null>, replace = false) => {
    setParams(
      (old) => {
        for (const [key, value] of Object.entries(values)) {
          if (value) old.set(key, value);
          else old.delete(key);
        }
        return old;
      },
      {
        replace: replace || openedHere,
        state: { ...location.state, equipmentOpened: location.pathname },
      },
    );
  };
  const close = (keys: string[]) => {
    if (openedHere) navigate(-1);
    else {
      const next = new URLSearchParams(params);
      keys.forEach((key) => next.delete(key));
      setParams(next, { replace: true, state: location.state });
    }
  };
  return { params, open, close, back };
}

export function EquipmentBack({
  crumbs = [],
  disabled = false,
  onBack,
}: {
  crumbs?: { label: string; to?: string }[];
  disabled?: boolean;
  onBack?: () => void;
}) {
  const navigate = useNavigate();
  const { back } = useEquipmentNavigation();
  return (
    <div className="equipment-backbar">
      <Button
        type="button"
        variant="outline"
        disabled={disabled}
        onClick={onBack ?? back}
      >
        ← Natrag
      </Button>
      <nav className="equipment-crumbs" aria-label="Putanja Opreme">
        {[{ label: "Oprema", to: "/oprema" }, ...crumbs].map((crumb, index) => (
          <Fragment key={`${index}:${crumb.label}`}>
            {index > 0 && <span aria-hidden="true">›</span>}
            <Button
              type="button"
              variant="outline"
              disabled={disabled}
              aria-label={
                !crumb.to ? `Trenutni ekran: ${crumb.label}` : crumb.label
              }
              aria-current={!crumb.to ? "page" : undefined}
              onClick={() => {
                if (crumb.to) navigate(crumb.to);
              }}
            >
              {crumb.label}
            </Button>
          </Fragment>
        ))}
      </nav>
    </div>
  );
}
